import { useState } from 'react';
import ProviderProps from '../../../domain/providers/ProviderProps';
import { injectable } from 'inversify';
import MasterDataContext, { defaultMasterDataContext } from './master_data_context';
import MasterDataContextType from '../../../domain/providers/master_data/master_data_context_type';
import MasterDataProvider from '../../../domain/providers/master_data/master_data_provider';
import MasterItemEntity from '../../../domain/entities/master_item.entity';

const _Actions: MasterDataContextType = defaultMasterDataContext;

const _Provider = ({ children }: ProviderProps) => {
  const [typesCall, setTypesCall] = useState<MasterItemEntity[]>([]);
  _Actions.typesCall = typesCall;
  _Actions.setTypesCall = setTypesCall;
  return (
    <MasterDataContext.Provider value={{ typesCall, setTypesCall }}>
      {children}
    </MasterDataContext.Provider>
  );
};

@injectable()
class MasterDataProviderImpl implements MasterDataProvider {
  public context = MasterDataContext;

  public Provider = _Provider;

  Actions = _Actions
}

export default new MasterDataProviderImpl();

